import React from "react";
import PropTypes from "prop-types";
import Price from "./Price";
import Body from "theme/components/atoms/Typography/Body";
import { FormattedMessage } from "react-intl";

const isFree = (price) => price.value.amount === 0;

const Free = () => (
  <FormattedMessage
    id="components.atoms.Typography.Price.PriceOrFree.free"
    defaultMessage="Free"
  />
);

const PriceOrFree = ({ price, freeLabel }) => {
  freeLabel = freeLabel || <Free />;
  return isFree(price) ? (
    <span className="price price--free">
      {typeof freeLabel === "string" ? <Body>{freeLabel}</Body> : freeLabel}
    </span>
  ) : (
    <Price price={price} />
  );
};

PriceOrFree.propTypes = {
  ...Price.propTypes,
  freeLabel: PropTypes.node,
};

export default PriceOrFree;
export { isFree };
